import { Link } from "react-router-dom";
import { mediaList } from "@/mocks/media";
import { useFavorites } from "@/hooks/useLocalLibrary";

export default function FavoritesRail() {
  const { favorites, toggleFavorite } = useFavorites();
  const items = favorites
    .map((id) => mediaList.find((item) => item.id === id))
    .filter((item): item is (typeof mediaList)[number] => Boolean(item));

  return (
    <section className="py-2 md:py-4">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-accent-800">
            <i className="ri-bookmark-line text-base" />
          </span>
          <h2 className="font-heading text-base font-semibold text-foreground-950">我的收藏</h2>
          <span className="rounded-full bg-background-100 px-2 py-0.5 text-[11px] text-foreground-500">
            {items.length} 部
          </span>
        </div>
        <Link
          to="/category/all"
          className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-700"
        >
          去发现更多作品
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      </div>

      {items.length > 0 ? (
        <div className="no-scrollbar flex gap-3 overflow-x-auto pb-1">
          {items.map((item) => (
            <div
              key={item.id}
              className="group flex w-[236px] shrink-0 items-center gap-3 rounded-lg border border-background-200/80 bg-background-50 p-2.5"
            >
              <Link to={`/detail/${item.id}`} className="flex min-w-0 flex-1 cursor-pointer items-center gap-3">
                <span className="h-[72px] w-[54px] shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={item.cover}
                    alt={`${item.title} 封面`}
                    title={`${item.title} - 我的收藏`}
                    className="h-full w-full object-cover object-top"
                  />
                </span>
                <span className="min-w-0">
                  <span className="block truncate text-[13px] font-medium text-foreground-900 group-hover:text-primary-700">
                    {item.title}
                  </span>
                  <span className="mt-1 block text-[11px] text-foreground-500">
                    {item.year} · {item.region}
                  </span>
                  <span className="mt-0.5 flex items-center gap-1 text-[11px] text-accent-700">
                    <i className="ri-star-fill text-[10px]" />
                    {item.rating.toFixed(1)}
                  </span>
                </span>
              </Link>
              <button
                type="button"
                onClick={() => toggleFavorite(item.id)}
                aria-label={`取消收藏 ${item.title}`}
                className="flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-full bg-background-100 text-foreground-500 transition-colors hover:bg-accent-100 hover:text-accent-800"
              >
                <i className="ri-close-line text-sm" />
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-dashed border-background-300 bg-background-50 px-4 py-3.5">
          <p className="text-xs leading-relaxed text-foreground-500">
            还没有收藏作品。打开任意影视详情页，点击「收藏作品」即可加入片单，刷新后依然保留。
          </p>
          <Link
            to="/category/all"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-950 px-3.5 py-2 text-[11px] font-medium text-background-50 transition-colors hover:bg-primary-800"
          >
            浏览作品
            <i className="ri-arrow-right-line text-xs" />
          </Link>
        </div>
      )}
    </section>
  );
}